import React from 'react';
import Modal from './modal';

interface Props {
  visible: boolean;
  name?: string;
  youtubeVideoId?: string;
  onClose: () => void;
}

/** Modal reutilizable para reproducir un video de YouTube embebido, sin
 * salir del sitio. Usado tanto en Guías y Tutoriales de cliente como de
 * abogado (ver src/screens/client/guides y src/screens/lawyer/guides). */
const GuideVideoModal = ({ visible, name, youtubeVideoId, onClose }: Props) => {
  return (
    <Modal
      className='modal-guide-video'
      visible={visible}
      title={name || 'Video'}
      centered
      onClose={onClose}
    >
      <div id='modal-guide-video'>
        {youtubeVideoId ? (
          <div className='video-wrapper'>
            <iframe
              src={`https://www.youtube.com/embed/${youtubeVideoId}?playsinline=1`}
              title={name || 'Video'}
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
          </div>
        ) : (
          <p>No se pudo cargar el video</p>
        )}
      </div>
    </Modal>
  );
};

export default GuideVideoModal;
